import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const personDataClassName = DataClassName.PERSON
const personEndpoint = PisaDataClassEndpoint.PERSON

export function pisaContactDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(personDataClassName, {
    title: personDataClassName,
    restApi: createPisaRestApiConfig(personEndpoint),
    attributes,
  })
}
